/**
 * The 5-element wheel (rule.md §8). Each element beats two, loses to two,
 * draws (standoffs) itself. Modeled as a beats-set so a future RPSLS-style
 * expansion is a data change, not a logic change.
 */

export type Element = "fire" | "water" | "plant" | "stone" | "ice";

export const ELEMENTS: readonly Element[] = [
  "fire",
  "water",
  "plant",
  "stone",
  "ice",
] as const;

/** What each element beats (rule.md §8 table). */
export const BEATS: Readonly<Record<Element, readonly Element[]>> = {
  fire: ["plant", "ice"],
  water: ["fire", "stone"],
  plant: ["water", "stone"],
  stone: ["fire", "ice"],
  ice: ["water", "plant"],
};

export const isElement = (value: unknown): value is Element =>
  typeof value === "string" && (ELEMENTS as readonly string[]).includes(value);
